import { localEndOfDayAsUtcIso, localStartOfDayAsUtcIso } from '../common/helpers/dateFns.helper';

import type { DemandDefinitionInput } from './types/DemandDefinitionInput';
import type { DemandDefinitionState } from './types/DemandDefinitionState';

type DemandDefinitionInputState = Pick<
    DemandDefinitionState,
    | 'adjustments'
    | 'fleetChanges'
    | 'leavingVessels'
    | 'excludedCompanyIds'
    | 'excludedProductCategories'
    | 'excludedProductKeys'
    | 'referencePeriodFrom'
    | 'referencePeriodTo'
>;

export const toDemandDefinitionRequestInput = (state: DemandDefinitionInputState): DemandDefinitionInput => ({
    referencePeriod: {
        from: state.referencePeriodFrom ? localStartOfDayAsUtcIso(state.referencePeriodFrom) : '',
        to: state.referencePeriodTo ? localEndOfDayAsUtcIso(state.referencePeriodTo) : '',
    },
    excludedCompanyIds: state.excludedCompanyIds,
    excludedProductCategories: state.excludedProductCategories,
    excludedProductKeys: state.excludedProductKeys,
    adjustments: state.adjustments,
    leavingVessels: state.leavingVessels.map(({ vesselId, plannedLeaving, handling }) => ({
        vesselId,
        plannedLeaving,
        handling,
    })),
    fleetChanges: state.fleetChanges.map(({ vesselId, handling, mirrorVesselId }) => ({
        vesselId,
        handling,
        mirrorVesselId,
    })),
});
